import { gql, useMutation } from '@apollo/client';
import useCustomerPriceVisibility from '../../core/hooks/useCustomerPriceVisibility';
import useFileDownload from '../../core/hooks/useFileDownload';
import useUserBranches from '../../core/queries/useUserBranches';
import type { DownloadStatus } from '../../core/types';
import useProductListQueryFilters from '../hooks/useProductListQueryFilters';

const requestProductsListMutation = gql`
    mutation requestProductsList(
        $store: ID!
        $language: Language!
        $categoryId: ID
        $filters: [ProductListFilter]
        $minPrice: Float
        $maxPrice: Float
        $search: String
        $onSale: Boolean
        $isNew: Boolean
        $states: [ProductState]
        $preorderSeasonId: Int
        $vehicleId: String
        $sparePartParentId: ID
        $sortField: ProductSortField
        $sortDirection: SortDirection
        $location: String!
        $hideDealerPrices: Boolean
        $bestAvailability: ProductBestAvailabilityFilter
    ) {
        requestProductsList(
            store: $store
            language: $language
            categoryId: $categoryId
            filters: $filters
            minPrice: $minPrice
            maxPrice: $maxPrice
            search: $search
            onSale: $onSale
            isNew: $isNew
            states: $states
            preorderSeasonId: $preorderSeasonId
            vehicleId: $vehicleId
            sparePartParentId: $sparePartParentId
            sortField: $sortField
            sortDirection: $sortDirection
            location: $location
            hideDealerPrices: $hideDealerPrices
            bestAvailability: $bestAvailability
        ) {
            id
            status
            url
        }
    }
`;

interface ProductListDownloadMutationResult {
    requestProductsList: {
        id: string;
        status: DownloadStatus;
    };
}

const useProductListCSVDownload = () => {
    const [shouldShowCustomerPrice] = useCustomerPriceVisibility();
    const { mainStock } = useUserBranches();

    const location = mainStock?.id;

    const getDownloadIdFromResult = (
        mutationData?: ProductListDownloadMutationResult
    ) => {
        return mutationData?.requestProductsList.id;
    };

    const { rootCategoryId, page, pageSize, ...variables } =
        useProductListQueryFilters();

    return useFileDownload(
        useMutation<ProductListDownloadMutationResult>(
            requestProductsListMutation
        ),
        {
            ...variables,
            location,
            hideDealerPrices: !shouldShowCustomerPrice,
        },
        getDownloadIdFromResult
    );
};

export default useProductListCSVDownload;
